import axios from 'axios';
import Cookies from 'js-cookie';
import buildApiRequestConfig from '../api/url-builder';
import routes from '../api/routes';

// After a checkout's payment is confirmed, tells the server to apply it
// straight from Stripe (POST .../stripe/sync) instead of waiting on Stripe's
// webhook - the plan only changes once the paid invoice is applied. Stripe
// can take a moment to mark the invoice paid after the card confirms, so this
// retries a few times until the company is off Free. Best effort: the
// subscription page also catches up on its own when read.
export const syncSubscriptionAfterPayment = async (entityId: number, attempts = 4): Promise<void> => {
    const { url, method } = buildApiRequestConfig(routes.subscription.stripeSync, [{ param: 'entityId', value: entityId }]);
    const token = Cookies.get('token');
    for (let i = 0; i < attempts; i++) {
        try {
            const { data } = await axios({ url, method, headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, data: {} });
            if (data?.tierId && data.tierId !== 'free') return;
        } catch {
            // try again below
        }
        await new Promise(resolve => setTimeout(resolve, 2000));
    }
};
